import { render, staticRenderFns } from "./SectionExperience.vue?vue&type=template&id=23ea987b&"
import script from "./SectionExperience.vue?vue&type=script&lang=js&"
export * from "./SectionExperience.vue?vue&type=script&lang=js&"
import style0 from "./SectionExperience.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports